import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { ErrorBoundary, PermissionProvider, ToastContainer, applyColourScheme } from '@/kit/ui'
import { useDevStore } from '@/store/devStore'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { useCurrentUser } from './useCurrentUser'

/** Sidebar + top bar + content, the permission provider for <Can>, the error boundary reset per route. */
export function Shell() {
  const location = useLocation()
  const { user, can } = useCurrentUser()
  const scheme = useDevStore((s) => s.colourScheme)
  useEffect(() => applyColourScheme(scheme), [scheme])

  return (
    <PermissionProvider value={{ can, roleLabel: user.role }}>
      <div className="flex min-h-full">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <TopBar />
          <main className="flex-1 p-4 lg:p-6">
            <ErrorBoundary key={location.pathname}>
              <Outlet />
            </ErrorBoundary>
          </main>
        </div>
      </div>
      <ToastContainer />
    </PermissionProvider>
  )
}
